import * as moment from 'moment';

export const getDate = (date) =>{
    return moment(date).format('DD/MM/YY')
}

export const getHour = (hour) =>{
    return moment(hour, 'H:m').format('HH:mm')
}

export const getFormatHour = (hour) =>{
    return moment(hour, 'HH:mm').format('HH:mm')
}

export const getCurrentTime = () => {
    return moment().valueOf();
}

export const getDay = (date) => {
    console.log(date)
    if(date){
     return date.day()   
    }
}

// date is Date type
export const getStartDate = (date, addDay = 0) => {
    return new Date(date.getUTCFullYear(), date.getMonth(), date.getDate() + addDay);
}